import { useEffect } from "react";
import PropTypes from "prop-types";
import { useLocation } from "react-router-dom";
import LocalStorage from "../../../ui/utils/LocalStorage";
import { RouteContext } from "./RouteContext";
import { FddApi } from "../../../ui/services/server-fdd";

export const RouteProvider = ({children}) => {
    const location = useLocation();
    useEffect(() => {
        //Si existe un draft almacenado en el localStorage, se actualiza en el servidor
        const localDraft = LocalStorage.getLocalDraft();

        console.log(localDraft);

        if (!localDraft) return;
        const {draftId, draft} = localDraft;

        console.log('[ROUTER PROVIDER] Se ha encontrado un draft enlocalStorage', localDraft);
        FddApi.updateDraft(draftId, draft);
        
    },[location.pathname]);

    return(
        <RouteContext.Provider value={{}}>
            {children}
        </RouteContext.Provider>
    )
}

RouteProvider.propTypes = {
    children: PropTypes.node.isRequired
}